import React from "react";
import $ from "jquery";
import {WebService} from "../../module/WebService";
import {AppConfig} from "../../AppConfig";
import 'bootstrap/dist/css/bootstrap.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import LoadingImage from "../LoadingImage";
import axios from "axios";
import {globalSession} from "../../module/Session";


class UserForm extends React.Component {

    webService = new WebService();

    send() {

        const _name = $("#name").val();
        const _registryNo = $("#registryNo").val();
        const _surname = $("#surname").val();
        const _pass1 = $("#pass1").val();
        const _pass2 = $("#pass2").val();
        const _mail = $("#mail").val();
        const _phone = $("#phone").val();

        let confirmedForm = true;
        let failMsg = "";


        if (_name.length < 3) {
            confirmedForm = false;
            failMsg += "Ad en az 3 karakterli olmalı<br>";
        }

        if (_surname.length < 3) {
            confirmedForm = false;
            failMsg += "Soyad en az 3 karakterli olmalı<br>";
        }
        if (!(/^[\d]{3,7}$/.test(_registryNo))) {
            confirmedForm = false;
            failMsg += "Geçersiz sicil no<br>";
        }

        if (_phone.length > 0) {
            if (!(/^[\d]{10,11}$/.test(_phone))) {
                confirmedForm = false;
                failMsg += "Geçersiz telefon no<br>";
            }
        }

        if (_mail.length > 0) {
            const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            if (!(_mail.length >= 3 && (re.test(_mail)))) {
                confirmedForm = false;
                failMsg += "Geçersiz e-posta adresi<br>";
            }
        }

        if (_pass1.length < 4) {
            confirmedForm = false;
            failMsg += "Şifreler en az 4 karakter olmalıdır<br>";
        }

        if (_pass1 !== _pass2) {
            confirmedForm = false;
            failMsg += "Şifreler aynı değil<br>";
        }
        /*alert(JSON.stringify({
            registryNo: _registryNo,
            name: _name,
            surname: _surname,
            password: _pass1,
            mail: _mail,
            phone: _phone
        }));*/

        if (confirmedForm) {
            $("#loadingImg").css({display: "block"});
            const param = {
                registryNo: _registryNo,
                name: _name,
                surname: _surname,
                password: _pass1,
                contact: {
                    mail: _mail,
                    phone: _phone
                }
            };

            axios.post(AppConfig.server + AppConfig.service.admin.users, param, globalSession.getAuthToken())
                .then((res) => {
                    const data = res.data;
                    if (data.success) {
                        this.success(data);
                    } else
                        this.fail();
                })
                .catch(e => {
                    this.fail();
                })

        } else {
            this.fail(failMsg);
        }
    }

    success(data) {
        if (data["success"] === true) {
            //alert("s1");
            $("#errorMsg").css({display: "none"}).html("");
            $("#successMsg").css({display: "block"}).html("Operator oluşturuldu");
            $("#name").val("");
            $("#registryNo").val("");
            $("#surname").val("");
            $("#pass1").val("");
            $("#pass2").val("");
            $("#mail").val("");
            $("#phone").val("");
        }
        $("#loadingImg").css({display: "none"});
    }

    fail(msg) {
        $("#errorMsg").css({display: "block"}).html("<strong>Başarısız</strong><br>" + msg);
        $("#successMsg").css({display: "none"}).html("");
        $("#loadingImg").css({display: "none"});
    }


    render() {
        return (
            <div style={{width: "100%"}}>
                <div style={{width: 600 + "px", margin: "125px auto"}}>
                    <div className="card">
                        <article className="card-body">
                            <h4 className="card-title text-center mb-4 mt-1"><strong>Yeni Operator</strong></h4>
                            <hr/>
                            <p id={"errorMsg"} className="text-danger text-center"/>
                            <p id={"successMsg"} className="text-success text-center"/>
                            <form>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="key"/></span>
                                        </div>
                                        <input id="registryNo" name="" className="form-control" placeholder="Sicil No."
                                               type="number"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="user"/></span>
                                        </div>
                                        <input id="name" name="" className="form-control" placeholder="Ad" type="text"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="user"/></span>
                                        </div>
                                        <input id="surname" name="" className="form-control" placeholder="Soyad"
                                               type="text"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="at"/></span>
                                        </div>
                                        <input id="mail" name="" className="form-control" placeholder="E-mail"
                                               type="email"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <FontAwesomeIcon icon="phone"/></span>
                                        </div>
                                        <input id="phone" name="" className="form-control" placeholder="Telefon"
                                               type="text"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <i className="fa fa-lock"/> </span>
                                        </div>
                                        <input id="pass1" className="form-control" placeholder="Şifre" type="password"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="input-group">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text"> <i className="fa fa-lock"/> </span>
                                        </div>
                                        <input id="pass2" className="form-control" placeholder="Şifre Tekrarı"
                                               type="password"/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <button onClick={this.send.bind(this)} type="button"
                                            className="btn btn-primary btn-block"> Kaydet
                                    </button>
                                </div>
                                <p style={{display: "none"}} id="loadingImg"><LoadingImage/></p>
                            </form>
                        </article>
                    </div>
                </div>
            </div>
        )
    }

}

export default UserForm;